import Intercom from '@intercom/messenger-js-sdk';
import { ENV, INTERCOM_KEY, PENDO_KEY } from 'utils/config';

const isProd = (ENV || '') === 'production';

/* User identification for analytics */
export const identify = (
  email: string,
  visitorData?: pendo.Identity['visitor'],
  accountData?: pendo.Identity['account']
): void => {
  try {
    if (PENDO_KEY) {
      pendo?.identify({
        visitor: {
          id: email,
          ...visitorData,
        },
        account: accountData,
      });
    }

    if (INTERCOM_KEY) {
      Intercom({
        app_id: INTERCOM_KEY,
        email: email,
      });
    }
  } catch (e) {
    console.log(e);
  }
};

export const event = (
  name: string,
  isSandboxMode = false,
  logTimestamp = true,
  metadata: pendo.Metadata = {}
): void => {
  // m_<event_name> : naming for merchant events

  if (logTimestamp && !metadata?.timestamp) {
    metadata.timestamp = new Date().toISOString().replace(/Z/, '+00:00');
    metadata.local_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  metadata.isSandboxMode = isSandboxMode;

  if (PENDO_KEY) pendo?.track(`m_${name}`, metadata);
};

export const reset = (): void => {
  if (isProd) {
    // TODO: Reset for analytics tools
  }
};

export const initialize = (isNativeMode?: boolean): void => {
  try {
    if (PENDO_KEY) pendo?.initialize();

    // to disable intercom widget when embedded in mso
    if (INTERCOM_KEY && !isNativeMode) {
      Intercom({
        app_id: INTERCOM_KEY,
      });
    }
  } catch (e) {
    console.log(e);
  }
};

export const TRACK = {
  initialize,
  identify,
  event,
  reset,
};
